import { useEffect, useState } from "react";
import { Button } from "../common/button/Button";
import { TrustPilotWidget } from "../ratings-integration/trustpilotWidget";
import { numberLetterPattern, validateRegistration } from "./Valuation.utils";
import GAHiddenInputs from "../common/gaHiddenInputs/gaHiddenInputs";

type Props = {
  registration: string;
  onRegistrationChange: Function;
  onSubmit: Function;
  addExistsInStock: Function;
  getStockStatus: Function;
  stockStatus?: boolean;
};

const Valuation: React.FC<Props> = ({
  registration,
  onRegistrationChange,
  onSubmit,
  addExistsInStock,
  getStockStatus,
  stockStatus
}) => {
  const [isValid, setIsValid] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [itExists, setItExists] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    setItExists(stockStatus);
  }, [stockStatus])

  useEffect(() => {
    if (itExists === false && isValid) {
      onSubmit();
      setErrorMessage("");
    }
    if (itExists) {
      setErrorMessage("Vehicle in stock, valuation not available");
      setShowError(true);
      addExistsInStock(undefined);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itExists, isValid])

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    if (numberLetterPattern.test(inputValue)) {
      onRegistrationChange(inputValue);
      setIsValid(validateRegistration(inputValue));
    }

    setShowError(false);
  };

  const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

	  if (isValid) {
      getStockStatus();
      setShowError(false);
      setErrorMessage("");
    } else {
      setErrorMessage("Enter a valid UK registration");
      setShowError(true);
      addExistsInStock(undefined);
    }
  };

  return (
    <div className="valuation-box">
      <h3 className="valuation-heading">Start here, it's simple.</h3>
      <p className="valuation-subheading">
        Enter your vehicle's registration to begin.
      </p>
      <form onSubmit={onSubmitHandler}>
        <GAHiddenInputs />
        <input
          required
          className={`valuation-registration ${isValid ? "valid" : ""}`}
          placeholder="Enter your registration"
          type="text"
          value={registration}
          onChange={onChangeHandler}
          data-testid="lkr-registration"
        />
        {showError && (
          <div className="valuation-error">
            <p>{errorMessage}</p>
          </div>
        )}				
        <Button
          variant="blue"
          className="value-your-car-btn"
          data-testid="lkr-value-your-car"
        >
          VALUE MY VEHICLE
        </Button>
      </form>
      <TrustPilotWidget />
    </div>
  );
};

export { Valuation };
